export default "__VITE_ASSET__vrcOTtLT__"